<template>
	<div class="text-left">
		<h1>Researcher Instructions Coming Soon</h1>
		<!-- <h1 class="text-center">Instructions</h1>
		<p>
			Step-by-step instructions, including screen shots, for setting-up a study to collect 24-hour recalls or food records are available for download to help researchers, clinicians, and educators use the ASA24 system. Also included in the instruction guides is information about data output and analysis.
		</p>
		<ul >
			<li>
				<a target="_blank" href="https://epi.grants.cancer.gov/asa24/resources/asa24-2020-researcher-instructions.pdf">Researcher Instructions for ASA24-2020 [PDF - 2.21 MB]</a></li>
			<li>
				<a target="_blank" href="https://epi.grants.cancer.gov/asa24/resources/asa24-2018-researcher-instructions-052021.pdf">Researcher Instructions for ASA24-2018 [PDF - 2.17 MB]</a>
			</li>
			<li>
				<a target="_blank" href="https://epi.grants.cancer.gov/asa24/resources/asa24-2016-researcher-instructions.pdf">Researcher Instructions for all 2016 versions and all 2014 versions [PDF - 2.17 MB]</a>
			</li>
		</ul>
		<p>
			See also <a target="_blank" href="https://epi.grants.cancer.gov/asa24/researcher/sample.html">sample analysis and data dictionaries</a> for more information.
		</p>
		<p>
			To learn more about 24-hour recalls and food records, visit NCI’s <a target="_blank" href="https://dietassessmentprimer.cancer.gov/">Dietary Assessment Primer</a>. The Primer can help researchers choose the best dietary assessment approach for their research objectives.
		</p> -->
	</div>
</template>

<script>
export default {
	name: 'Instructions'
}
</script>

<style>

</style>
